import React, { useEffect, useState } from 'react';

import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';
import {
  MenuItemType,
  RoleTypes,
  TRoutes,
  TcolorsPaletteFromBO,
  HookReturnType,
} from './types';
import HeaderContextProvider from './HeaderContextProvider';

interface TProps {
  menuItems: MenuItemType[];
  isMenuItemsLoading: boolean;
  isStoreEnabled: boolean | undefined;
  userFirstname: string;
  appLogo: JSX.Element;
  routes: TRoutes;
  colorsPaletteFromBO: TcolorsPaletteFromBO;
  programUrl: string;
  canAccessBo: boolean;
  userRoles: RoleTypes[] | undefined;
  totalRewardsValue?: number;
  t: (value: string) => string;
  useLogout: () => HookReturnType;
  navigate: (url: string) => void;
}

const SharedHeader = ({
  menuItems,
  isMenuItemsLoading,
  isStoreEnabled,
  userFirstname,
  totalRewardsValue,
  appLogo,
  routes,
  colorsPaletteFromBO,
  programUrl,
  canAccessBo,
  userRoles,
  t,
  useLogout,
  navigate,
}: TProps) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 960);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 960);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <HeaderContextProvider
      programUrl={programUrl}
      canAccessBo={canAccessBo}
      userRoles={userRoles}
      colorsPaletteFromBO={colorsPaletteFromBO}
      appLogo={appLogo}
      routes={routes}
      menuItems={menuItems}
      isMenuItemsLoading={isMenuItemsLoading}
      isStoreEnabled={isStoreEnabled}
      totalRewardsValue={totalRewardsValue}
      userFirstname={userFirstname}
      t={t}
      useLogout={useLogout}
      navigate={navigate}
    >
      {isDesktop ? <HeaderDesktop /> : <HeaderMobile />}
    </HeaderContextProvider>
  );
};

export default SharedHeader;
